<template>
  <div class="pin-input">
    <div class="pin-cells">
      <span
        v-for="(digit, idx) in pin"
        :key="idx"
        class="pin-cell"
        :class="{ filled: !!digit }"
      >{{ digit ? '•' : '' }}</span>
    </div>
    <div class="pin-buttons">
      <div
        v-for="n in [1,2,3,4,5,6,7,8,9]"
        :key="n"
        class="pin-btn"
        @click="pressDigit(n)"
        :class="{ blink: blinkIndex === n }"
        tabindex="0"
      >{{ n }}</div>
      <div class="pin-btn action" @click="pressReset" tabindex="0">
        ✕
      </div>
      <div class="pin-btn" @click="pressDigit(0)" :class="{ blink: blinkIndex === 0 }" tabindex="0">0</div>
      <div class="pin-btn action" @click="pressConfirm" :class="{ disabled: !isFull }" :aria-disabled="!isFull" tabindex="0">
        ✓
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PinInput',
  props: {
    autoFocus: { type: Boolean, default: false },
    autoConfirm: { type: Boolean, default: true }
  },
  data() {
    return {
      pin: ['', '', '', ''],
      blinkIndex: null
    };
  },
  computed: {
    isFull() {
      return this.pin.every(i => i);
    }
  },
  mounted() {
    if (this.autoFocus) this.focusFirst();
  },
  watch: {
    autoFocus(val) {
      if (val) this.$nextTick(() => this.focusFirst());
    }
  },
  methods: {
    focusFirst() {
      // no-op, for compatibility
    },
    pressDigit(n) {
      if (!this.isFull) {
        n = String(n);
        for (let i = 0; i < 4; i++) {
          if (!this.pin[i]) {
            this.pin[i] = n;
            this.emitChange();
            this.triggerBlink(n);
            if (this.autoConfirm && this.isFull) this.confirmPin();
            return;
          }
        }
        // If already full, do nothing
        this.triggerBlink(n);
      }
    },
    pressReset() {
      if (!this.pin.some(f => f)) this.$emit('close');
      this.reset();
    },
    pressConfirm() {
      if (this.isFull) this.confirmPin();
    },
    confirmPin() {
      this.$emit('enter');
      this.reset();
    },
    triggerBlink(n) {
      /*this.blinkIndex = n;
      setTimeout(() => (this.blinkIndex = null), 150);*/
    },
    emitChange() {
      this.$emit('change', this.pin.join(''));
    },
    reset() {
      this.pin = ['', '', '', ''];
      this.emitChange();
    }
  }
};
</script>

<style scoped lang="scss">
.pin-input {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  user-select: none;
}
.pin-cells {
  display: flex;
  gap: 14px;
  margin-bottom: 8px;
}
.pin-cell {
  width: 48px;
  height: 56px;
  font-size: 2.1em;
  border-radius: 14px;
  border: 2px solid #ffffff55;
  background: rgba(255,255,255,0.13);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.16s, border-color 0.16s;
  box-shadow: 0 1px 8px 0 rgba(0,0,0,0.10);
}
.pin-cell.filled {
  font-weight: bold;
  background: rgba(255,255,255,0.22);
  border-color: #ffffff;
}
.pin-buttons {
  display: grid;
  grid-template-columns: repeat(3, 60px);
  grid-template-rows: repeat(4, 54px);
  gap: 12px;
  justify-content: center;
  align-content: center;
  margin-top: 6px;
}
.pin-btn,
.pin-btn.action {
  box-shadow: none;
  outline: none;
  overflow: hidden;
  font-size: 2em;
  font-family: inherit;
  background: rgba(255,255,255,0.15);
  color: #fff;
  border-radius: 12px;
  border: none;
  box-shadow: 0 1px 4px 0 rgba(0,0,0,0.10);
  cursor: pointer;
  transition: background 0.14s, color 0.14s;
  font-weight: bold;
  outline: none;
  position: relative;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;

  &:focus {
    box-shadow: none;
    outline: none;
  }

  &.disabled {
    opacity: 0.6;
    pointer-events: none;
  }
}
.pin-btn:active,
.pin-btn.blink {
  background: rgba(255,255,255,0.25);
  color: #fff;
}
.pin-btn.action {
  font-size: 1.7em;
  background: rgba(255,255,255,0.18);
}
.pin-btn.action.disabled {
  opacity: 0.6;
  pointer-events: none;
}

/* Remove tap highlight on mobile/Chrome */
.pin-btn, .pin-btn.action {
  -webkit-tap-highlight-color: transparent;
}
</style>